import React from "react";

const PrefixNameContext = React.createContext<string>("");

export default PrefixNameContext;
